<!--
 * @Author: your name
 * @Date: 2021-07-12 16:29:48
 * @LastEditTime: 2021-09-15 14:37:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\allCategoriesDialog.vue
-->
<template>
  <div>
    <el-dialog
     :append-to-body="true"
      title="联系我们"
      width="600px"
      :destroy-on-close="true"
      :visible.sync="dialogVisible"
      @close='closeDialog'>
      <div class="dialog-content">
          <el-form :model="formData" :rules="rules" ref="ruleForm">
              <el-form-item label="联系人：" label-width="120px" prop="contacts">
                <el-input minlength="2"  maxlength="20" v-model="formData.contacts" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="联系方式：" label-width="120px" prop="phone">
                <el-input  v-model="formData.phone" autocomplete="off"></el-input>
              </el-form-item>
          </el-form>
          <div class="title">
            <p>提示：</p>
            <p>1.联系人可输入2-20字符</p>
            <p>2.联系方式可输入座机号，座机号必须加区号。例如：010-12345678</p>
          </div>
        <div slot="footer" class="dialog-footer flex-c">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitData('ruleForm')">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
 import {
  mobilePhone,
  verifyCntacts
} from "@/modules/projectA/utils/validate";
export default {
   props:{
        activeName: {
            type: String,
            default: ''
        },
        contactUsInfo:{
          type:Object,
          default: function () {
            return {
              phone:'',
              contacts:''
            }
          }
        }
  },
  data(){
      return {
          dialogVisible:false,
          formData:{
            phone:'',
            contacts:''
          },
          rules: {
            phone: [
              { required: true, message: '请输入联系电话', trigger: 'blur' },
              { validator: mobilePhone, trigger: "blur" }
            ],
            contacts: [
              { required: true, message: '请输入联系人', trigger: 'blur' },
              { validator: verifyCntacts, trigger: "blur" }
            ]
          }
      }
  },
  watch: {
      activeName(newV,oldV) {
          console.log(newV,oldV)
          this.dialogVisible= newV=='contactUs'?true:false;
          this.formData.phone=this.contactUsInfo.phone;
          this.formData.contacts=this.contactUsInfo.contacts;
      } 
  },
  methods: {
      submitData(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
             this.contactUsInfo.phone=this.formData.phone;
             this.contactUsInfo.contacts=this.formData.contacts;
             this.dialogVisible=false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      
      
    closeDialog(){
        this.$parent.choosenComments('');
    },
  }
};
</script>
<style lang="scss" scoped>

.title{
  width:100%;
  display:flex;
  flex-direction: column;
  box-sizing: border-box;
  padding:0 0 20px 40px;
}
.content-div{
    width:100%;
    padding:10px;
    height:500px;
    border:1px solid #FFA900;;
    margin-top: 10px;
    border-radius: 10px;
    overflow: auto;
    .custom-tree-node{
        width: 100%;
        .label-name{
            line-height: 28px;
        }
        
         .handle-btn{
             float: right;
            align-items: center;
         }
    }
}
.tag-btn{
  margin-right: 10px;
}
</style>
